// Place names arrive from Hotelbeds in inconsistent casing — "BANGKOK" next to "Istanbul",
// "ROMA" next to "Rome" — so any list that shows them side by side looks like scraped data.
// toTitleCase normalises them for DISPLAY only; the stored value is what we still send back
// as a filter value, so matching stays exact.

// Word boundaries that start a new capital: whitespace, hyphen, slash, apostrophe, dot and
// opening brackets. That keeps "l'hospitalet" → "L'Hospitalet" and "aix-en-provence" →
// "Aix-En-Provence" rather than capitalising only the very first letter of the string.
const WORD_START = /(^|[\s\-–—/\\.'’([])([\p{L}\p{N}])/gu;

export const toTitleCase = (value) => {
  const text = String(value ?? '').trim();
  if (!text) return '';
  return text
    .toLocaleLowerCase()
    .replace(WORD_START, (_, sep, ch) => sep + ch.toLocaleUpperCase());
};

export default toTitleCase;
